import { useState, useRef, useMemo } from "react";
import { toPng } from "html-to-image";
import { digitsEnToFa } from "@persian-tools/persian-tools";
import configs from "utils/globals";
import { getUserData } from "containers/services/data.transformers";

import ReceiptSharing from "components/receiptSharing";
import TransactionContent from "./components/transactionContent";
import TransactionHeader from "./components/header";
import { ReactComponent as BankPattern } from "assets/images/bank-card/bank-receipt-pattern.svg";

import "./index.scss";

const TransactionsReceipt = () => {
  const elementRef = useRef();

  const newQueries = JSON.parse(localStorage.getItem("bank_receipt"));
  const [user, setUser] = useState({});

  const getUser = async () => {
    const userData = await getUserData();
    setUser(userData);
  };

  useMemo(async () => {
    await getUser();
  }, []);

  const renderTitle = () => {
    switch (newQueries?.type?.toLowerCase()) {
      case "profit":
        return "deposit-profit";

      case "deposit":
        return "money-transfer";

      case "fee":
        return "wage";

      case "withdraw":
        return "money-transfer";

      default:
        return "";
    }
  };

  const handleDownloadImage = async () => {
    configs.base64toFile({
      filename: `${newQueries.date}.png`,
      isDownloadFail: true,
    });
  };

  const handleShareWithImage = () => {
    configs.base64toFile({
      filename: `${newQueries.date}.png`,
    });
  };

  const handleShareWithImageText = () => {
    const { amount, description, date } = newQueries ?? {};

    const newAmount = [
      "مبلغ:",
      `${digitsEnToFa(`${amount?.toLocaleString()}`)}`,
      "ریال",
    ];
    const text = [
      `تاریخ و زمان: ${digitsEnToFa(`${date}`)}`,
      newAmount.join(" "),
      `انتقال دهنده: ${user?.name}`,
      `شماره پیگیری: ${digitsEnToFa(`${description}`)}`,
    ];

    return {
      title: "",
      text: text.join("\n"),
    };
  };

  return (
    <div className="relative">
      <div className="fixed left-1/2 -translate-x-1/2 translate-y-0 max-w-3xl m-auto h-[100vh] bg-gray--12 w-full overflow-auto z-10">
        <TransactionHeader title={renderTitle()} />
        <div className="w-[100% - 20px] bg-cover bg-[url('https://cdn.firouzeh.com/public/bank-resid-pattern.png')] bg-center-top bg-no-repeat rounded-xl shadow-xl mx-5 py-5 ">
          <TransactionContent
            {...newQueries}
            withdraw={newQueries?.type?.toLowerCase() === "withdraw"}
          />
          <ReceiptSharing
            shareWithImageText={handleShareWithImageText()}
            onDownloadImage={handleDownloadImage}
            onShareImage={handleShareWithImage}
          />
        </div>
      </div>

      <div className="fixed left-1/2 -translate-x-1/2 translate-y-0 overflow-hidden rounded-lg top-[0] w-[420px] h-[832px]">
        {/* 'https://cdn.firouzeh.com/public/bank-receipt-pattern.png */}
        <div
          className="w-[420px] h-auto font-dana rounded-lg px-5 py-[78px] flex justify-center items-center bg-cover bg-yellow bg-center-top bg-no-repeat"
          id="content"
          ref={elementRef}
        >
          <BankPattern className="absolute right-0 top-0 w-full h-[832px] " />
          <TransactionContent
            className="bg-white"
            {...newQueries}
            withdraw={newQueries?.type?.toLowerCase() === "withdraw"}
          />
        </div>
      </div>
    </div>
  );
};

export default TransactionsReceipt;
